export enum TattooParlorEvent {
  Exit = "tattooParlorExit",
  GetState = "tattooParlorGetState",
  BuyTattoo = "tattooParlorBuyTattoo",
  RemoveTattoo = "tattooParlorRemoveTattoo",
  SetClientTattoo = "tattooParlorClientSetTattoo",
  ResetClientTattoos = "tattooParlorClientResetTattoos",
}
